<template>

    <div class="single-specials">

        <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>

        <transition name="long-fade">
            <div v-if="!loading && data">

                <ion-row>
                    <ion-col size="12">
                        <div class="padding">
                            <div class="text-center">
                                <h1 class="text-normal mb-10">{{ title }}</h1>
                            </div>
                        </div>
                    </ion-col>
                    <ion-col size="12" size-md="8" offset-md="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3" class="pd-0" >
                        <div class="image-wrapper">
                            <ion-img :src="image" class="image" :alt="title" />
                        </div>
                    </ion-col>
                    <ion-col size="12" size-sm="10" offset-sm="1" size-md="8" offset-md="2" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                        <div class="padding">
                            <!--title-->
                            <div class="text-left">
                                <h2 class="h3 mb-0">Termin</h2>
                                <p class="mt-0">tylko do <span class="text-red">{{dateTo}}</span></p>
                            </div>
                            <!--rte-->
                            <div class="entry rte" v-html="content"></div>
                            <hr/>
                            <!--targets-->
                            <div v-if="targets" class="targets-list" >
                                <div class="item" v-for="(item, index) in targets">
                                    <h3 v-if="item.target" class="h3 mt-0 mb-0">
                                        <span class="text-light text-normal">{{ item.title }}:</span>
                                        <span class="text-light text-normal">{{item.target}} punktów</span>
                                    </h3>
                                    <h3 v-if="item.bonus" class="h3 mt-0 mb-0">
                                        <span class="text-light text-normal">Bonus:</span>
                                        <span class="text-light text-red text-normal">{{item.bonus}} złotych punktów</span>
                                    </h3>
                                    <div v-html="item.description"></div>
                                </div>
                            </div>
                            <!--additional info-->
<!--                            <hr/>
                            <p>Nie masz jeszcze tego produktu w swojej ofercie lub masz dodatkowe pytania?
                              Skontaktuj się z obsługującym Cię przedstawicielem handlowym VOX Profile:&nbsp;
                              <strong class="nowrap">
                                <span>{{ user.superior.name }} tel.</span>
                                <a :href="`tel:${ user.superior.phone }`">{{ user.superior.phone }}</a>
                              </strong>
                            </p>-->
                            <!--<button class="btn btn-primary" @click="goToList">Wróć do listy zadań</button>-->
                        </div>
                    </ion-col>
                </ion-row>
            </div>
        </transition>

    </div>

</template>

<script>
    import { mapState } from 'vuex'
    import SpecialsServices from '../../../services/SpecialsServices';

    export default {
        name: 'SpecialsList',
        props: {
            slug : {
                type: [String, Number],
                requred: true
            }
        },
        data: () =>({
            loading: true,
            errors: [],
            data: null
        }),
        computed:{
            ...mapState(['user']),
            //
            image(){
                return this.data.image;
            },
            title(){
                return this.data.title;
            },
            content(){
                return this.data.content;
            },
            targets(){
                return this.data.targets;
            },
            dateFrom(){
                return this.data.dateFrom;
            },
            dateTo(){
                return this.data.dateTo;
            }
        },
        methods: {
            getData() {
                this.loading = true;
                SpecialsServices.getSpecialTask(this.slug)
                    .then( (response) => {
                        this.loading = false;

                        if(response.code == 0){
                            this.errors.push(response.message)
                        }else{
                            this.data = response.data.data;
                        }
                        // FIX scroll to top
                        const element = document.querySelector('#topOfDocument');
                        element.scrollIntoView()
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                    })
            },
            goToList() {
                this.$router.push({ name: 'SpecialsList' })
            }
        },
        mounted(){
            this.getData();
        }
    }
</script>
